import {Injectable} from '@angular/core';
import {environment} from '~local/environments/environment';
import {StompService} from './StompService';

@Injectable()
export class RouterStompService extends StompService {
  protected getStompConfig() {
    return {
      brokerURL: environment.routerSocketHost,
    }
  }
}
